var blockquote_default = {
  "fontElementMap": "jpZrJ",
  "quote": "mmTUe"
};
export {
  blockquote_default as default
};
//# sourceMappingURL=blockquote-scss.js.map
